import * as Sentry from '@sentry/browser';
// import { CUSTOME_TRACE_ID } from './utils'

export const report = (args) => {
  const res = args.res || {}
  const config = args.config || res.config || {}
  let fullUrl = args.url || config.url || ''
  const idx = fullUrl.indexOf(`?`)
  let url = ''
  if (idx > -1) {
    url = fullUrl.substr(0, idx)
  } else {
    url = fullUrl
  }
  let msg = args.msg || args.error || ''
  if (typeof(msg) === 'object') {
    msg = msg.msg || ''
  }
  Sentry.withScope(scope => {
    scope.setExtras({
      url: fullUrl,
      params: args.params || '',
      config: JSON.stringify(config),
      trace_id: args.traceID || '',
      responseBody: JSON.stringify(args.res || args.error || ''),
      message: msg
    })
    Sentry.captureException(`接口${url}, msg: ${msg}`)
  })
}
